import LegalPage from '../components/LegalPage'

export default function SignerTerms() {
  return <LegalPage type="SIGNER_TERMS" />
}
